/*eslint-disable @typescript-eslint/ban-types*/
/*eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { ExecutionPlan, NoOperationAction } from './ExecutionPlan';
import { useEffectOnce } from '../../../globalUtils/globalExports';
import { cloneDeep } from 'lodash';


interface NoOpNodeProps {
    data: {
        executionPlan: ExecutionPlan,
        handleUpdateExecutionPlan: Function,
        nodeId: string;
        parentNodeId: string;
        ifOrElse: string;
    }
}



const NoOpNode: React.FC<NoOpNodeProps> = (props) => {
  return <div style={{ width: 0, height: 0, overflow: 'hidden' }} />;
};
export default NoOpNode;